import React, { Component } from 'react';
import './../sass/Footer.css';

class Footer extends Component {
    constructor() {
        super();
        this.state = {};
    }
    render() {
        return (
            <footer
                role="contentinfo"
                className="app-footer"
                id="app-footer"
                data-testid="footer-wrapper"
            ></footer>
        );
    }
}
export default Footer;
